import { render, staticRenderFns } from "./GlobalSearch.vue?vue&type=template&id=74b83f2c&"
import script from "./GlobalSearch.vue?vue&type=script&lang=ts&"
export * from "./GlobalSearch.vue?vue&type=script&lang=ts&"
import style0 from "./GlobalSearch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports